// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__ZODbl","nav-opened":"layout_nav-opened__ImKR-"};